import React from 'react';
import styled from 'styled-components';

const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 160px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
              border-color 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }

  &.active {
    border-color: ${({ $theme }) =>
      $theme === 'light' ? '#333' : '#aaa'};
  }

  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    transition: box-shadow 0.3s ease;
  }

  &:hover img {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  .book-title {
    margin-top: 0.75rem;
    font-size: 0.85rem;
    font-weight: 600;
    line-height: 1.3;
    color: ${({ $theme }) =>
      $theme === 'light' ? '#333' : '#eee'};
    text-align: center;
  }

  .book-author {
    font-size: 0.75rem;
    color: ${({ $theme }) =>
      $theme === 'light' ? '#888' : '#999'};
    margin-top: 0.2rem;
    text-align: center;
  }

  @media (max-width: 768px) {
    width: 130px;

    img {
      height: 180px;
    }
  }
`;

const BookCard = ({ title, author, coverUrl, isActive, onClick, theme }) => {
  return (
    <Card
      $theme={theme}
      className={isActive ? 'active' : ''}
      onClick={onClick}
      aria-expanded={isActive}
    >
      {coverUrl && <img src={coverUrl} alt={`Cover of ${title}`} />}
      <span className="book-title">{title}</span>
      <span className="book-author">{author}</span>
    </Card>
  );
};

export default BookCard;
